import { TElement } from "@udecode/plate-common";
import React from "react";
import MultipleItemsQuestionBox, {
  IMultipleItemQuestionBoxAnswer,
} from "../composite/MultipleItemsQuestionBox";
import { ICheckInQuestionPropsBase } from "../CheckInQuestions";

interface IMultipleChoiceQuestionProps
  extends ICheckInQuestionPropsBase<IMultipleItemQuestionBoxAnswer> {
  element: TElement;
  handleSetNode: (dataToSet: object) => void;
}

const MultipleChoiceQuestion = ({
  element,
  handleSetNode,
  view,
  disableAnswer,
}: IMultipleChoiceQuestionProps) => {
  return (
    <MultipleItemsQuestionBox
      type={"radio"}
      element={element}
      handleSetNode={handleSetNode}
      view={view}
      disableAnswer={disableAnswer}
    />
  );
};

export default MultipleChoiceQuestion;
